import React from 'react';
import {MoneyBackIcon} from './icons';
import './money-back.scss';

const MoneyBack = ({moneyBack}) => (
  <div className="money-back-container card">
    <div className="money-back-title">
      <MoneyBackIcon />
      {moneyBack}% Money Back
    </div>
    <div className="money-back-text">
      We return your money back automatically if this strategy will not be profitable.
    </div>
  </div>
);

export default MoneyBack;
